const STORAGE_KEY = 'cybernovel_a11y_settings';

/** Préférences d'accessibilité du joueur, mémorisées dans le navigateur. */
export interface A11ySettings {
  /** Mode accessibilité renforcée (malvoyants) pendant les histoires. */
  strictMode: boolean;
}

const DEFAULT_SETTINGS: A11ySettings = {
  strictMode: false,
};

export function getA11ySettings(): A11ySettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<A11ySettings> | null;
    return {
      strictMode: parsed?.strictMode === true,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveA11ySettings(settings: A11ySettings): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        strictMode: settings.strictMode === true,
      })
    );
  } catch {
    // Stockage indisponible (navigation privée, quota) : le choix vaut pour la session.
  }
}

/**
 * Mouvement réduit : préférence système `prefers-reduced-motion` ou mode
 * accessibilité renforcée actif (`html[data-a11y="strict"]`).
 */
export function isMotionReduced(): boolean {
  if (typeof document !== 'undefined' && document.documentElement.dataset.a11y === 'strict') {
    return true;
  }
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;
}
